import styled from 'styled-components';
import { pxToRem, fontWeight, vars } from '$util/theme';
import { getBreakpoint } from '$util/theme/breakpoints';
import { Modal } from '$quantum/atoms/ModalDeprecated';
import { Card } from '$components/basic/Card';

export const ModalStyled = styled(Modal)`
  width: 800px !important;
  max-width: 100%;

  .ant-modal-body {
    padding: 120px 24px;
    text-align: center;

    .title {
      font-size: 2rem;
      font-weight: ${fontWeight.light};
    }
    .content {
      font-size: 1.6em;
      font-weight: ${fontWeight.light};
      margin: 25px 0;
    }
    .ant-btn {
      font-weight: ${fontWeight.bold};
      margin-top: 10px;
      box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
      padding: 13px;
    }
    .-covered {
      .title {
        color: #29b67a;
      }
      .ant-btn {
        width: 65%;
      }
    }
    .-no-coverage {
      .title {
        color: ${vars.red};
      }
      .ant-btn {
        height: auto;
        margin-top: 28px;
        padding: 13px 25px;
      }
      .email-container {
        text-align: left;
        font-size: ${pxToRem(13)};
        padding-left: 25px;
      }
      input {
        padding: 5px 14px;
        height: 53px;
        margin-top: 10px;

        &.-error {
          border-color: ${vars.red};
        }
      }
      .no-spam {
        color: ${vars.quantumverse.reskinColors.neutral300};
        padding-top: 10px;
        display: block;
      }
      @media (max-width: ${getBreakpoint('sm')}) {
        .ant-col {
          width: 100%;
          display: block;
        }
        .email-container {
          padding-left: 0;
          margin-left: 0;
        }
        .ant-btn {
          width: 65%;
        }
        .content {
          font-size: 1.2em;
        }
      }
    }
  }
  .ant-modal-close {
    display: block;
    color: ${vars.red};

    .anticon-close {
      background: none;
    }
  }
  .hidden {
    display: none;
  }
`;

export const CardStyled = styled(Card)`
  max-width: 626px;
  padding: 48px;

  @media (max-width: ${getBreakpoint('sm')}) {
    max-width: 100%;
    padding: 0;

    &.card-1 {
      background: transparent;
      box-shadow: none;
    }
  }

  .heading {
    color: #3a82e9;
    font-weight: ${fontWeight.bold};
    font-size: ${pxToRem(18)};
    margin-bottom: 24px;
  }

  .top-section {
    display: flex;

    .input-helper {
      font-size: ${pxToRem(14)};

      @media (max-width: ${getBreakpoint('md')}) {
        font-size: ${pxToRem(15)};
      }
    }

    .input-error {
      border: solid 1px red;
    }

    .error-input-message {
      color: ${vars.red};
      font-size: ${pxToRem(12)};
      padding-top: 5px;
      text-align: left;
    }

    .postcode {
      @media (max-width: ${getBreakpoint('sm')}) {
        margin-bottom: 18px;
      }

      @media (min-width: ${getBreakpoint('sm')}) {
        padding-right: 12px !important;
      }
    }

    .postcode {
      width: 100%;

      input {
        margin-top: 5px;
      }
    }

    .search-btn-container {
      width: 31%;
      @media (max-width: ${getBreakpoint('sm')}) {
        width: 100%;
      }
    }
  }

  @media (max-width: ${getBreakpoint('sm')}) {
    .top-section {
      display: block;

      .postcode_input {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
  .bottom-section {
    margin-top: 24px;
  }

  .search-btn-container {
    margin-top: 32px;
  }

  .react-autosuggest__input {
    height: auto !important;
  }
`;
